export default {
  BusinessLogisticsCompanyPostCode: {
    country: '国家',
    state: '州',
    suburb: '区',
    postcode: '邮编',
    dataFormTitle_Add: '新增邮编',
    dataFormTitle_Edit: '编辑邮编',
    label: 'Label',
    labelSub: 'LabelSub',
    zone: 'Zone',
    ps1: '起始邮编不可以大于结束邮编！',
  }
};
